import { useState } from "react";
import { createPortal } from "react-dom";
import { CATEGORY_DESCRIPTIONS } from "@/data/categoryDescriptions";

/**
 * Кружечок «?» поряд зі сферою (онбординг + профіль). По тапу — bottom-sheet
 * з назвою сфери та поясненням «що сюди входить» (юзер 2026-06-10: люди не
 * розуміли, які вакансії входять у кожну сферу).
 *
 * Самодостатній: тримає власний стан попапа, шукає опис по slug. Якщо опису
 * немає — іконка не рендериться. stopPropagation на кліку, щоб не
 * перемикати вибір категорії (рядок-кнопка під ним).
 */
export function CategoryInfo({ slug, name }: { slug: string; name: string }) {
  const [open, setOpen] = useState(false);
  const desc = CATEGORY_DESCRIPTIONS[slug];
  if (!desc) return null;

  return (
    <>
      <button
        type="button"
        aria-label={`Що входить у «${name}»`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        className="grid h-6 w-6 shrink-0 place-items-center rounded-full border border-ink/20 font-display text-[0.75rem] font-bold leading-none text-ink-dim active:scale-90 transition"
      >
        ?
      </button>

      {open &&
        createPortal(
          <div
            className="fixed inset-0 z-[120] flex items-center justify-center bg-black/45 px-6 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          >
            <div
              className="catinfo-pop relative w-full max-w-sm overflow-hidden rounded-ios-hero bg-surface p-6 shadow-ai-card"
              onClick={(e) => e.stopPropagation()}
            >
              {/* мʼякий помаранчевий акцент у кутку */}
              <div
                className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full"
                style={{
                  background:
                    "radial-gradient(circle, rgba(254,107,4,0.18), rgba(254,107,4,0))",
                }}
              />
              <div className="relative">
                <div className="mb-2 flex items-center gap-2">
                  <span className="grid h-6 w-6 place-items-center rounded-full bg-primary/10 font-display text-[0.8125rem] font-bold leading-none text-primary">
                    ?
                  </span>
                  <span className="font-mono text-[0.625rem] uppercase tracking-[0.12em] text-ink-dim">
                    що входить у сферу
                  </span>
                </div>
                <div className="mb-2 font-display text-[1.1875rem] font-bold leading-tight text-ink">
                  {name}
                </div>
                <p className="text-[0.875rem] leading-relaxed text-ink-dim">{desc}</p>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="mt-5 w-full rounded-2xl bg-primary py-3 font-display text-[0.9375rem] font-semibold text-white shadow-card active:scale-[0.98] transition"
                >
                  Зрозуміло
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
